'use strict';
var trainScheduleTrainScheduleEntryDetailsTpl = require('./train-schedule-entry-details.html');
var util = require('../util/property-util');
var arrayUtil = require('../util/array-util');
var FileSaver = require('file-saver');
var Bloodhound = require('../../node_modules/typeahead.js/dist/bloodhound');

module.exports = /*@ngInject*/ [ "TrainScheduleFactory", "NgTableParams", "$filter", "ProjectService", "$q", "$uibModal", "TrainScheduleCrudFactory", "TrainScheduleExportFactory", "$timeout", "TrainService",
function TrainScheduleController(TrainScheduleFactory, NgTableParams, $filter, ProjectService, $q, $uibModal, TrainScheduleCrudFactory, TrainScheduleExportFactory, $timeout, TrainService) {
    var vm = this;
    vm.loading = true;
    vm.scheduleDate = new Date();
    vm.currentTrain = undefined;
    vm.currentSchedule = [];
    var trainSchedule = new Map();

    var trains ;
    var waypoints;
    var timetable;
    var schedule;
    
    vm.inputTimetable = undefined;
    var timetableData = [];
    

    vm.timetableVisible = true;
    vm.importing = false;

    vm.newTimetableEntry = {};

    vm.serviceId = "";

    vm.serviceIdError = undefined;

    vm.inputTrainScheduleTable = undefined;
    vm.importingTrainSchedule = false;
    vm.timetableImport = {
        success: undefined,
        error: undefined
    };

    vm.trainScheduletTableImport  = {
        success: undefined,
        error: undefined
    };

    vm.inputWaypoints = undefined;

    vm.controlPossibilities = [];
    vm.showImportTimeTable = false;
    vm.showImportTrainSchedule = false;
    vm.showImportWaypoints = false;

    vm.trainIdentifiers = [{
        fieldName: 'relativeId',
        displayedName: 'I18N_SCHEDULING.INTERNAL_ID'
      },
      {
        fieldName: 'officialId',
        displayedName: 'I18N_SCHEDULING.OFFICIAL_ID'
    }];
    vm.currentTrainIdentifier = vm.trainIdentifiers[0];

    vm.scrollToCurrentTrain = function() {
        scrollToCurrentTrain(true)
    }

    vm.getScheduleForTrain = function (trainId) {
        return trainSchedule.get(trainId);
    };

    init();

    /*
     FUNCTIONS
     */

    function init() {

        var promises = [
            TrainService.getTrains().query({
                "projectId": ProjectService.getSelectedProjectId()
            }).$promise,
            TrainScheduleCrudFactory.getWaypoints(ProjectService.getSelectedProjectId()),
            TrainScheduleCrudFactory.getTimetable(ProjectService.getSelectedProjectId()),
            TrainScheduleCrudFactory.getTrainSchedule(new Date())
        ]

        Promise.all(promises).then(([trainsData, waypointsData, timetableData, todaysPlanningData]) => {
            trains = trainsData;
            waypoints = waypointsData;
            timetable = timetableData;
            schedule = todaysPlanningData;

            vm.loading = false;
            vm.trains = trains && trains.map(train => {
                train.officialId = isNaN(train.officialId) ? train.officialId : parseInt(train.officialId);
                return train;
            });
            vm.waypoints = waypoints;
            vm.currentTimetable = timetable;
            vm.schedule = schedule;
    
            vm.timetableParams = createTimetableTable();

            if (vm.trains.length > 0) {
                const trainsWithServices = vm.trains.filter(train => {
                    const services = vm.getScheduleForTrain(train.relativeId);
                    return services && services.length > 0
                }) 
    
                if (trainsWithServices && trainsWithServices[0]) {
                    setSelectedTrainById(trainsWithServices[0].relativeId);
                }
               
                createSchedule();
            }
    
            if (util.isDefined(timetable)) {
                timetableData = TrainScheduleFactory.parseDatabaseTimetable(timetable, waypoints);
                vm.timetableParams.reload();
                createPossibleControls();
    
            }

            
        })


    }

    /*
     CONTROLS
     */

    vm.serviceIdAction = function (serviceId) {
        vm.serviceIdError = undefined;
        switch (serviceId) {
            case "r":
                deleteSchedule(vm.currentTrain.relativeId);
                break;
            case "n":
                var currentIndex = TrainScheduleFactory.getTrainIndex(vm.currentTrain.relativeId, vm.trains);
                var nextIndex = (currentIndex + 1) % (vm.trains.length);
                setSelectedTrainById(vm.trains[nextIndex].relativeId);
                scrollToCurrentTrain(true);
                break;
            case "p":
                var currentIndex = TrainScheduleFactory.getTrainIndex(vm.currentTrain.relativeId, vm.trains);
                var previousIndex = (currentIndex - 1);

                if (previousIndex < 0) {
                    previousIndex = vm.trains.length - 1;
                }
                setSelectedTrainById(vm.trains[previousIndex].relativeId);
                scrollToCurrentTrain(false);
                break;
            case "":
            case undefined:
                break;
            default:
                if (isValidServiceId(serviceId) && !scheduleContainsServiceId(vm.currentTrain.relativeId, serviceId)) {
                    createTableEntry(serviceId, vm.currentTrain.relativeId, vm.scheduleDate);
                } else {
                    vm.serviceIdError = "Not a valid Service ID";
                }
        }
        vm.serviceId = "";
    };

    vm.setSelectedTrainById = function (id) {
        setSelectedTrainById(id);
    };

    vm.trainIdentifierChanged = () => {
        vm.trains = vm.trains.sort((t1, t2) => t1[vm.currentTrainIdentifier.fieldName] - t2[vm.currentTrainIdentifier.fieldName] > 0 ? 1 : -1 )
        setTimeout(() => scrollToCurrentTrain(), 0);
    }

    function isValidServiceId(serviceId) {
        return getTimetableEntry(serviceId) !== undefined;
    }

    function setSelectedTrainById(id) {
        var train = TrainScheduleFactory.getTrainById(vm.trains, id);
        if (util.isDefined(train)) {
            vm.currentTrain = train;
        }
    }

    

    function scrollToCurrentTrain(scrollToTop) {
        if (vm.currentTrain) {
            const trainsWithActiveService = vm.trains.filter(train => !!vm.getScheduleForTrain(train.relativeId))
            .map(train => train[vm.currentTrainIdentifier.fieldName]);
        if (trainsWithActiveService && trainsWithActiveService.length > 0) {
            var idx = trainsWithActiveService.indexOf(vm.currentTrain[vm.currentTrainIdentifier.fieldName]);
            document.getElementById("trainScheduleDiv").scrollTop = document.getElementById("trainScheduleDiv").scrollHeight * (idx-1)/trainsWithActiveService.length;
        }
        }       
    }

    function createPossibleControls() {

        var possibilities = ['r', 'n', 'p'];
        vm.currentTimetable.forEach(function (timetableEntry) {
            possibilities.push(timetableEntry.serviceId);
        });

        // instantiate the bloodhound suggestion engine
        vm.serviceSearch = new Bloodhound({
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            datumTokenizer: Bloodhound.tokenizers.whitespace,
            local: possibilities
        });

        // initialize the bloodhound suggestion engine
        var promise = vm.serviceSearch.initialize();
    }

    vm.filter = function (query) {
        vm.serviceSearch.search(query, function (d) {
            vm.searchResults = arrayUtil.isNotEmptyArray(d) ? d.slice(0, 5) : [];
        }, function (d) {
        });
    };

    vm.onTabSelectFirstMatch = function () {
        var copy = angular.copy(vm.searchResults);
        if (util.isDefined(copy)) {
            var firstResult = copy.slice(0, 1)[0];
            if (firstResult === vm.serviceId) {
                vm.serviceIdAction(vm.serviceId);
                $timeout(function () {
                    vm.searchResults = [];
                }, 500);
            } else {
                vm.serviceId = firstResult;
                vm.filter(vm.serviceId);
            }
        }
    };

    vm.setFinalValue = function (result) {
        vm.serviceId = angular.copy(result);
    };


    /*
     TIMETABLE
     */

    vm.saveNewTimetableEntry = function () {
        if (!isValidServiceId(vm.newTimetableEntry.serviceId)) {
            var savePromise = TrainScheduleCrudFactory.saveTimetableEntry(vm.newTimetableEntry, ProjectService.getSelectedProjectId());
            savePromise.then(function () {
                var promise = TrainScheduleCrudFactory.getTimetable(ProjectService.getSelectedProjectId());
                promise.then(function (newTimetable) {
                    timetable = newTimetable;
                    timetableData = TrainScheduleFactory.parseDatabaseTimetable(newTimetable, waypoints);
                    vm.timetableParams.reload();
                    createPossibleControls();

                });
                vm.newTimetableEntry = {};
                vm.newTableEntryForm.$setPristine();
            });
        } else {
            vm.newTableEntryForm.serviceId.$invalid = true;
        }
    };

    vm.checkServiceIdFormField = function (serviceId) {
        vm.newTableEntryForm.serviceId.$invalid = isValidServiceId(serviceId);
    };


    function createTimetableTable() {
        return new NgTableParams({
            page: 1,            // show first page
            count: 5,           // count per page
            sorting: {id: 'asc'}
        }, {
            counts: [],         // hide page counts control
            total: timetableData.length, // length of data
            getData: function (params) {
                // use build-in angular filter
                var orderedData = params.sorting() ? $filter('orderBy')(timetableData, params.orderBy()) : timetableData;
                orderedData = params.filter ? $filter('filter')(orderedData, params.filter()) : orderedData;
                params.count(orderedData.length);
                params.total(orderedData.length);
                return orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
            }
        });
    }

    function getTimetableEntry(serviceId) {
        var found = undefined;
        timetable.some(function (entry) {
            if (entry.serviceId === serviceId) {
                found = entry;
                return true;
            }
        });

        return found;
    }


    /*
     SCHEDULE
     */


    vm.onSelectedDateChange = (date) => {
        vm.loading = true;
        vm.scheduleDate = date;
        fetchSchedule(vm.scheduleDate);
    }
    vm.fetchSchedule = function () {
        fetchSchedule(vm.scheduleDate);
    };



    function scheduleContainsServiceId(trainId, serviceId) {
        var schedule = trainSchedule.get(trainId);

        var found = false;
        if (util.isDefined(schedule)) {
            schedule.some(function (scheduleEntry) {
                if (scheduleEntry.serviceId === serviceId) {
                    found = true;
                    return true;
                }
            });
        }
        return found;
    }

    function fetchSchedule(date) {
        if (angular.isDate(date)) {
            var planningPromise = TrainScheduleCrudFactory.getTrainSchedule(date);

            planningPromise.then(function (planning) {
                vm.loading = false;
                vm.schedule = planning;
                createSchedule();
            });
        }
    }

    function createTableEntry(serviceId, trainId, scheduleDate) {
        var timetableEntry = getTimetableEntry(serviceId);
        var waypointStart = TrainScheduleFactory.getWaypointByAbbreviation(timetableEntry.startStation, waypoints);
        var waypointEnd = TrainScheduleFactory.getWaypointByAbbreviation(timetableEntry.endStation, waypoints);

        var startTime = timetableEntry.start;
        var endTime = timetableEntry.end;
        var timestamp = scheduleDate;

        //endDate = TrainScheduleFactory.setTime(endDate, timetableEntry.end);
        var savePromise = TrainScheduleCrudFactory.saveTrainScheduleEntry(trainId, waypointStart.id, waypointEnd.id, startTime, endTime, serviceId, timestamp);
        savePromise.then(function () {
            fetchSchedule(vm.scheduleDate);
        });
    }

    function deleteSchedule(trainId) {
        var schedule = trainSchedule.get(trainId);
        if (util.isDefined(schedule)) {
            var promises = [];
            schedule.forEach(function (scheduleEntry) {
                promises.push(TrainScheduleCrudFactory.removeTrainScheduleEntry(scheduleEntry.id, ProjectService.getSelectedProjectId()));
            });
            $q.all(promises).then(function () {
                fetchSchedule(vm.scheduleDate);
            });
        }
    }

    function createSchedule() {
        trainSchedule = new Map();
        vm.schedule.forEach(function (entry) {
            var current = [];
            if (trainSchedule.has(entry.trainId)) {
                current = trainSchedule.get(entry.trainId);
            }
            current.push(entry);
            trainSchedule.set(entry.trainId, current);
        });
    }


    /*
     EXPORT
     */
    vm.exportPlanning = function () {
        var csvString = TrainScheduleExportFactory.getExportPlanningCsvString(vm.schedule);
        var blob = new Blob([csvString], {type: "text/plain;charset=utf-8"});
        var fileName = "" + $filter('tzdate')(vm.scheduleDate, "YYYY-MM-DD") + ""
            + "_" + "schedule" +
            ".csv";

        FileSaver.saveAs(blob, fileName);
    };

    vm.exportReport = function () {
        TrainScheduleExportFactory.getExportReportCsvString(vm.scheduleDate);
    };


    vm.processCsvTrainScheduleTable = function () {
        vm.trainScheduletTableImport = {
            success: undefined,
            error: undefined
        };
        var trainScheduleTablePromise = TrainScheduleExportFactory.parseTrainScheduleTableCsv(vm.inputTrainScheduleTable);
        trainScheduleTablePromise.then(function (timeScheduleList) {
            vm.showImportTrainSchedule = false;
            if (timeScheduleList && timeScheduleList.length === 0) {
                vm.trainScheduletTableImport.error = "I18N_SCHEDULING.SCHEDULE_EMPTY";
            } else {
                var invalidServices = {};
                timeScheduleList.forEach(function(timeSchedule) {
                    timeSchedule.serviceIds.forEach(function(currentServiceId){
                        if (isValidServiceId(currentServiceId) && !scheduleContainsServiceId(timeSchedule.trainRelativeId, currentServiceId)) {
                            createTableEntry(currentServiceId, timeSchedule.trainRelativeId, vm.scheduleDate);
                        } else {
                            invalidServices[currentServiceId] = true;
                        }
                    });
    
                });

                if (Object.keys(invalidServices).length <= 1) {
                    vm.trainScheduletTableImport.success = "I18N_SCHEDULING.UPLOAD_SUCCESSFUL";
                } 
                if (Object.keys(invalidServices).length > 1) {
                    vm.trainScheduletTableImport.error = "I18N_SCHEDULING.SERVICE_INVALID";
                }
            }
            vm.inputTrainScheduleTable = undefined;
            vm.importingTrainSchedule = false;
        }, function (errorMsg) {
            vm.trainScheduletTableImport.error = errorMsg;
            vm.importingTrainSchedule = false;
        });
    }

    vm.processCsvTimetable = function () {
        vm.timetableImport = {
            success: undefined,
            error: undefined
        };

        var timetablePromise = TrainScheduleExportFactory.parseTimetableCsv(vm.inputTimetable, vm.waypoints);
        timetablePromise.then(function (data) {
            var savePromise = TrainScheduleCrudFactory.saveTimetable(data, vm.waypoints, ProjectService.getSelectedProjectId());
            savePromise.then(function () {
                var promise = TrainScheduleCrudFactory.getTimetable(ProjectService.getSelectedProjectId());
                promise.then(function (newTimetable) {
                    timetable = newTimetable;
                    timetableData = TrainScheduleFactory.parseDatabaseTimetable(newTimetable, waypoints);
                    vm.timetableParams.reload();
                    createPossibleControls();

                    vm.timetableImport.success = "I18N_SCHEDULING.UPLOAD_SUCCESSFUL";
                    vm.timetableVisible = true;
                    vm.importing = false;
                });
            }, function (errorMsg) {
                vm.timetableImport.error = "I18N_SCHEDULING.UPLOAD_FAILED";
                vm.importing = false;
            });
        }, function (errorMsg) {
            vm.timetableImport.error = errorMsg;
            vm.importing = false;
        });
    };

    vm.processCsvWaypoints = function () {
        var files = document.getElementById('inputWaypointsFile').files[0];

        TrainScheduleCrudFactory.saveWaypoints(files, ProjectService.getSelectedProjectId()).then(function (savedWaypoints) {
            vm.importing = false;
        });

    }

    vm.exportTimetable = function () {
        var csvString = TrainScheduleExportFactory.getExportTimetableCsvString(timetableData);
        var blob = new Blob([csvString], {type: "text/plain;charset=utf-8"});
        var fileName = "" + $filter('tzdate')(vm.scheduleDate, "YYYY-MM-DD") + ""
            + "_" + "timetable" +
            ".csv";

        FileSaver.saveAs(blob, fileName);
    };

    /*
     MODAL DETAILS
     */

    vm.showInfo = function (scheduleEntry) {

        if (util.isDefined(scheduleEntry)) {
            var modal = $uibModal.open({
                template: trainScheduleTrainScheduleEntryDetailsTpl,
                controller: "TrainScheduleEntryDetailsController as vm",
                resolve: {
                    scheduleEntry: function () {
                        return scheduleEntry;
                    },
                    waypoints: function () {
                        return waypoints;
                    }
                }
            });

            modal.result.then(function (object) {
                var data = object.data;

                if (object.action === 'save') {
                    //TODO: verify start and end date or time?
                    var updatePromise = TrainScheduleCrudFactory.updateTrainScheduleEntry(data.id, data.trainId, data.startStation.id, data.endStation.id, data.start, data.end, data.serviceId);

                    updatePromise.then(function () {
                        fetchSchedule(vm.scheduleDate);
                    });

                } else if (object.action === 'delete') {
                    var removePromise = TrainScheduleCrudFactory.removeTrainScheduleEntry(data.id, ProjectService.getSelectedProjectId());
                    removePromise.then(function () {
                        fetchSchedule(vm.scheduleDate);
                    });
                }
            }, function () {
            });
        }
    };
}];

